/*eslint-disable*/
import React, { useState, useEffect } from "react";
import { STYLES } from "config";
import {
    MenuItem,
    Select
} from '@mui/material';
import { useSelector, useDispatch } from "react-redux";

import {
    Input,
    Button,
} from "reactstrap";

import CustomDropDownPicker from "./CustomDropDownPicker";
import moment from "moment";


import SearchWithSuggestionsEnquiries from "./CustomeSearchWithSuggestionsEnquiries"

const styles = {
    container: {
        padding: "5px",
        backgroundColor: STYLES.PRIMARY_APP_CLR,
        borderRadius: "4px",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
        width: "100%",
    },
    divider: {
        height: "1px",
        backgroundColor: STYLES.WEB_APP_FONT_CLR,
        margin: "10px 0",
    },

    section: {
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "5px",
    },

    subSection: {
        display: "flex",
        alignItems: "center",
        padding: "10px",
    },

    standardButton: { backgroundColor: STYLES.PRIMARY_BUTTON_CLR, color: "white" },

    selectorButtons: { backgroundColor: STYLES.PRIMARY_BUTTON_CLR, color: "white", width: "8px", hight: "10px", display: "flex", alignItems: "center", justifyContent: "center" },

    whiteFont: { color: "white", fontSize: "12px", fontWeight: "bold" },

    inputStyle: {
        borderWidth: 1,
        borderColor: STYLES.TERTIARY_APP_CLR,
        height: 54,
        backgroundColor: "white",
        fontSize: 16,
        borderRadius: 2,
        color: "grey",
        paddingRight: 30,
    },

    advancedFilter: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
    },
    advancedFilterRow: {
        gap: "10px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        padding: "5px",
    },

};

const CustomAdvanceEnquiryFilter = ({
    setView,
    setDisplayedEnquiries,
    currentEnquiries,
    filteredEnquiries,
    setFilteredEnquiries
}) => {
    //usestates
    const [currentPage, setCurrentPage] = useState(1);
    const [advanced, setAdvanced] = useState(false);
    const [brokerList, setBrokerList] = useState([]);
    const [propertyTypeList, setPropertyTypeList] = useState([]);
    const [itemsPerPage, setitemsPerPage] = useState(10)
    const [filterstate, setFilterState] = useState({
        endDate: false,
        startDate: false,
        industrialCommercial: false,
        sizeRangeMin: false,
        sizeRangeMax: false,
        Proptype: [],
        Broker: [],
        web_Ref_No: "",
    });


    //constants
    const usedListings = filteredEnquiries.length > 0 ? filteredEnquiries : currentEnquiries;
    const totalPages = Math.ceil(usedListings.length / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;

    const usageTypes = [
        { value: "Commercial", label: "Commercial", },
        { value: "Industrial", label: "Industrial", },
    ]


    const saleTypes = [
        { value: "both", label: "Both", },
        { value: "sale", label: "Sale", },
        { value: "tolet", label: "Tolet", },
        { value: "All", label: "All", },
    ]

    const propTypes = [
        "Vacant Land",
        "Retail",
        "Office",
        "Building",
    ];

    //Reducer
    const brokers = useSelector((state) => state.brokers.users);
    const auth = useSelector((state) => state.auth);

    //UseEffect to set intial display of data

    useEffect(() => {
    let allowed = propTypes;

    if (filterstate.industrialCommercial === "Commercial") {
        allowed = ["Vacant Land", "Retail", "Office"];
    }

    if (filterstate.industrialCommercial === "Industrial") {
        allowed = ["Vacant Land", "Building"];
    }

    const filteredPropTypes = allowed.map((p) => ({
        value: p,
        label: p,
    }));

    setPropertyTypeList(filteredPropTypes);

    // reset property types when usage type changes
    filterEnquiries("Proptype", []);
}, [filterstate.industrialCommercial]);


    useEffect(() => {
        const displayedListings = usedListings.slice(
            startIndex,
            startIndex + itemsPerPage
        );

        setDisplayedEnquiries(displayedListings);
    }, [currentPage, filteredEnquiries, currentEnquiries,itemsPerPage])




    useEffect(() => {
        let arr = [];
        if (brokers) {
            for (let index = 0; index < brokers.length; index++) {
                const element = brokers[index];

                // Populate the list with all brokers, remove brokerHomeOffice filter
                if (element.brokerHomeOffice === auth?.info?.profile?.adminHomeOffice) {
                    arr.push({
                        value: element.id, // The broker ID (or name if preferred)
                        label: `${element.firstName} ${element.lastName}`, // Broker name
                    });
                }
            }
            setBrokerList(arr.sort((a, b) => a.label.localeCompare(b.label)));
        }


        let propArr = [];
        if (propTypes) {
            for (let index = 0; index < propTypes.length; index++) {
                const element = propTypes[index];

                propArr.push({
                    value: element,
                    label: element,
                });

            }
            setPropertyTypeList(propArr);
        }

    }, [brokers]);


    //functions
    const filterEnquiries = (filter, info) => {
        setFilterState({
            ...filterstate,
            [filter]: info,
        });
    };
    const clearFilter = () => {
        setFilterState({
            industrialCommercial: false,
            sizeRangeMin: false,
            sizeRangeMax: false,
            Proptype: [],
            Broker: [],
            web_Ref_No: "",
        }
        )

        setFilteredEnquiries([])
        alert(`Filter Cleared`)
    }
    const filter = () => {
        let filtered = [];
        let error = false;




        let startDate = moment(filterstate.startDate).valueOf();
        let endDate = moment(filterstate.endDate).valueOf();

        if (filterstate) {
            // Check if Min size is greater than Max size, but allow proceeding if either size is empty
            if (
                filterstate.sizeRangeMin !== "" &&
                filterstate.sizeRangeMax !== "" &&
                parseInt(filterstate.sizeRangeMin) > parseInt(filterstate.sizeRangeMax)
            ) {
                alert("Min Filter Size cannot be greater than max size");
                return;
            }

            if ((filterstate.startDate && filterstate.endDate) && (startDate > endDate)) {
                alert("End Date Before Start Date");
                return;

            }

            // Loop through enquiries and apply all relevant filters
            currentEnquiries.map((enquiry) => {
                // Broker matching condition




                let brokerMatch = false;

                if (filterstate.Broker.length === 0) {
                    brokerMatch = true;
                } else {
                    for (let index = 0; index < filterstate.Broker.length; index++) {
                        if (enquiry?.userdetials?.id === filterstate.Broker[index]) {
                            brokerMatch = true;
                        }
                    }
                }

                // const brokerMatch =
                //   !filterstate.Broker || enquiry.userdetials?.id === filterstate.Broker;

                // Size range matching condition (only applies if size range is provided)
                const sizeMatch =
                    (!filterstate.sizeRangeMin ||
                        parseInt(filterstate.sizeRangeMin) <= parseInt(enquiry.sizeMax)) &&
                    (!filterstate.sizeRangeMax ||
                        parseInt(enquiry.sizeMin) <= parseInt(filterstate.sizeRangeMax));

                // PROPERTY TYPE FILTER (STRING BASED) — READY TO PASTE
                let typeOfPropertyMatch = true;

                // console.log("Selected Property Types:", filterstate.Proptype);
                // console.log("Enquiry Property Type:", enquiry.typeOfProperty);

                // Only apply filter if user selected property types
                if (filterstate.Proptype.length > 0) {

                    // If enquiry has no property type, reject it
                    if (!enquiry.typeOfProperty || enquiry.typeOfProperty === "") {
                        typeOfPropertyMatch = false;

                    } else {

                        // Normalize enquiry type
                        const enquiryProp = enquiry.typeOfProperty.toLowerCase().trim();

                        // Compare against the STRING values in the filter list
                        typeOfPropertyMatch = filterstate.Proptype.some(
                            (p) =>
                                p &&
                                p.toLowerCase().trim() === enquiryProp
                        );
                    }
                }


                const zoningMatch = !filterstate.industrialCommercial || enquiry.industrialCommercial === filterstate.industrialCommercial;

                const typeMatch =
                    !filterstate.type || enquiry.type === filterstate.type;


                const dateMatch =
                    (!startDate ||
                        startDate <= enquiry.enquiryDate) &&
                    (!endDate ||
                        endDate >= enquiry.enquiryDate);

                // Push enquiry to filtered list if all conditions match

                if (brokerMatch && sizeMatch && typeOfPropertyMatch && typeMatch && dateMatch && zoningMatch) {
                    filtered.push(enquiry);
                }
            });

            // Final processing of the filtered results
            if (!error) {
                if (filtered.length > 0) {
                    setFilteredEnquiries(filtered);
                    alert(`Filter Set \n Number of Enquiries: ${filtered.length}`);
                } else {
                    alert("No enquiries match the selected filters.");
                }
            }
        } else {
            alert("Please enter search options!");
        }
    };


    //Retrun of the screen
    return <div style={styles.container}>

        <div style={styles.section}>

            {!advanced && (<>
                <div style={styles.subSection}>

                    <SearchWithSuggestionsEnquiries
                        currentEnquiries={currentEnquiries}
                        setFilteredEnquiries={setFilteredEnquiries}
                    />


                    {/* <Input
                        fullWidth
                        type="text"
                        style={{ ...styles.inputStyle, borderColor: "#f00000" }}
                        placeholder="Search by Keyword"

                        onChange={(e) => { }}
                    /> */}
                </div>

                <div style={styles.subSection}>

                    <Button
                        type="submit"
                        style={styles.standardButton}
                        onClick={() => {
                            setAdvanced(true);
                        }}
                    >
                        Advanced Filter
                    </Button>

                </div>
            </>)}

            {advanced && (<>
                <div style={styles.advancedFilter}>

                    <div style={styles.advancedFilterRow}>
                        <Input
                            fullWidth
                            type="number"
                            style={styles.inputStyle}
                            placeholder="min size"
                            onChange={(e) => filterEnquiries("sizeRangeMin", e.target.value)}
                            value={filterstate.sizeRangeMin}
                        />

                        <Input
                            fullWidth
                            type="number"
                            style={styles.inputStyle}
                            placeholder="max size"
                            onChange={(e) => filterEnquiries("sizeRangeMax", e.target.value)}
                            value={filterstate.sizeRangeMax}
                        />


                        <div style={{ width: "100%" }}>
                            <CustomDropDownPicker
                                options={brokerList}
                                isMulti={true}
                                value={filterstate.Broker}
                                onChange={(e) => filterEnquiries("Broker", e)}
                                placeholder="Select A Broker"
                            />
                        </div>


                    </div>




                    <div style={styles.advancedFilterRow}>
                        <Input
                            fullWidth
                            type="date"
                            style={styles.inputStyle}
                            placeholder="From Date"
                            onChange={(e) => filterEnquiries("startDate", e.target.value)}
                        />

                        <Input
                            fullWidth
                            type="date"
                            style={styles.inputStyle}
                            placeholder="To Date"
                            onChange={(e) => filterEnquiries("endDate", e.target.value)}
                        />
                    </div>

                    <div style={styles.advancedFilterRow}>
                        <div style={{ width: "100%" }}>
                            <CustomDropDownPicker
                                options={propertyTypeList}
                                isMulti={true}
                                value={filterstate.Proptype}
                                onChange={(selected) => filterEnquiries("Proptype", selected)}
                                placeholder={"Select Property Type"}
                            />
                        </div>

                        <div style={{ width: "100%" }}>
                            <CustomDropDownPicker
                            options={usageTypes}
                            isMulti={false}
                            value={filterstate.industrialCommercial}
                            onChange={(e) => filterEnquiries("industrialCommercial", e)}
                            placeholder="Select A Usage Type"
                        />
                        </div>

                        <div style={{ width: "100%" }}><CustomDropDownPicker
                            options={saleTypes}
                            isMulti={false}
                            value={filterstate.type}
                            onChange={(e) => filterEnquiries("type", e)}
                            placeholder="Select A Sale Type"
                        />
                        </div>

                    </div>


                    <div style={styles.advancedFilterRow}>

                        <div style={styles.advancedFilterSearchClearRow}>

                            <Button
                                type="submit"
                                style={{ ...styles.standardButton, width: "140px" }}
                                onClick={() => {
                                    filter();
                                }}
                            >
                                Search
                            </Button>

                            <Button
                                type="submit"
                                style={{ ...styles.standardButton, backgroundColor: "red" }}
                                onClick={() => {
                                    clearFilter();
                                }}
                            >
                                Clear
                            </Button>

                        </div>

                        <Button
                            type="submit"
                            style={{ ...styles.standardButton, backgroundColor: "red" }}
                            onClick={() => {
                                setAdvanced(false);
                            }}
                        >
                            Collapse
                        </Button>


                    </div>
                </div>
            </>

            )}


        </div>

        <div style={styles.divider} />

        <div style={styles.section}>

            <div style={styles.subSection}>

                <Button
                    style={styles.selectorButtons}
                    onClick={() => {
                        setView('list');
                    }}
                >
                    <i className="now-ui-icons files_paper" />
                </Button>

                <Button
                    style={styles.selectorButtons}
                    onClick={() => {
                        setView('table');
                    }}
                >
                    <i className="now-ui-icons design_image" />
                </Button>

            </div>

            <div style={{
                ...styles.subSection,
                gap: "10px",
            }}>

                <Select
                    value={itemsPerPage}
                    onChange={(e) => setitemsPerPage(Number(e.target.value))}
                    size="small"   // shorter height
                    sx={{
                        backgroundColor: "white",
                        height: "32px",        // short height
                        '& .MuiSelect-select': {
                            padding: "4px 10px", // reduce inner padding
                        },
                        '& fieldset': {
                            borderColor: '#ccc', // optional border color
                        },
                        '&:hover fieldset': {
                            borderColor: '#999',
                        },
                    }}
                >
                    <MenuItem value={10}>10</MenuItem>
                    <MenuItem value={20}>20</MenuItem>
                    <MenuItem value={30}>30</MenuItem>
                </Select>

                <span style={styles.whiteFont}>
                    {" "}
                    Page {currentPage} of {totalPages}{" "}
                </span>

                <Button
                    style={styles.selectorButtons}
                    onClick={() => {
                        setCurrentPage((prev) => prev - 1);
                    }}
                >
                    <i className="now-ui-icons arrows-1_minimal-left" />
                </Button>

                <Button
                    style={styles.selectorButtons}
                    onClick={() => {
                        setCurrentPage((prev) => prev + 1);
                    }}
                >
                    <i className="now-ui-icons arrows-1_minimal-right" />
                </Button>


            </div>

        </div>

    </div >;
};

export default CustomAdvanceEnquiryFilter;